/* eslint-disable no-unused-vars */
import { FormStepTypes } from "constants/";

export enum RequestFormActionType {
  LOCATION_DETAIL_SUCCESS = "LOCATION_DETAIL_SUCCESS",
  SCHEDULE_DETAIL_SUCCESS = "SCHEDULE_DETAIL_SUCCESS",
  FREIGHT_MODE_REQUEST_SUCCESS = "FREIGHT_MODE_REQUEST_SUCCESS",
  PAYMENT_LOCATION_SUCCESS = "PAYMENT_LOCATION_SUCCESS",
  SERVICE_REQUEST_SUCCESS = "SERVICE_REQUEST_SUCCESS",
  PROVIDER_REQUEST_SUCCESS = "PROVIDER_REQUEST_SUCCESS",
  UPDATE_DRAFT_SAVE = "UPDATE_DRAFT_SAVE",
  UPDATE_UNSAVED_CHANGES = "UPDATE_UNSAVED_CHANGES",
  PACKING_DETAIL_SUCCESS = "PACKING_DETAIL_SUCCESS",
  UPDATE_DISABLED_FIELDS = "UPDATE_DISABLED_FIELDS",
  UPDATE_TOOLTIP_FIELDS = "UPDATE_TOOLTIP_FIELDS",
}

export type RequestFormAction = {
  payload: any;
  type: RequestFormActionType;
};

export type RequestFormState = {
  locationDetails: any;
  scheduleDetails: any;
  service: any;
  freightModes: any;
  paymentLocations: any;
  providers: any;
  draftSaved: Record<string, boolean>;
  unsavedChanges: Record<string, boolean>;
  packingList: any;
  disabledFields: any;
  tooltipFields: any;
};

export const initialState: RequestFormState = {
  locationDetails: {},
  scheduleDetails: {},
  service: {},
  freightModes: {},
  paymentLocations: {},
  providers: {},
  draftSaved: {
    [FormStepTypes.ORGANISATION]: false,
    [FormStepTypes.SCHEDULE]: false,
    [FormStepTypes.PACKING_LIST]: false,
    [FormStepTypes.SERVICE]: false,
    [FormStepTypes.PROVIDER]: false,
  },
  unsavedChanges: {
    [FormStepTypes.ORGANISATION]: false,
    [FormStepTypes.SCHEDULE]: false,
    [FormStepTypes.PACKING_LIST]: false,
    [FormStepTypes.SERVICE]: false,
    [FormStepTypes.PROVIDER]: false,
  },
  packingList: { attachment: [], nmfcOption: [], dangerousGoods: [], handlingUnitOptions: {} },
  disabledFields: {},
  tooltipFields: {},
};

export const reducer = (state: RequestFormState, action: RequestFormAction) => {
  switch (action.type) {
    case RequestFormActionType.LOCATION_DETAIL_SUCCESS:
      return {
        ...state,
        locationDetails: {
          ...state.locationDetails,
          ...action.payload,
        },
      };
    case RequestFormActionType.SCHEDULE_DETAIL_SUCCESS:
      return {
        ...state,
        scheduleDetails: {
          ...state.scheduleDetails,
          ...action.payload,
        },
      };
    case RequestFormActionType.FREIGHT_MODE_REQUEST_SUCCESS:
      return {
        ...state,
        freightModes: {
          ...state.freightModes,
          ...action.payload,
        },
      };
    case RequestFormActionType.PAYMENT_LOCATION_SUCCESS:
      return {
        ...state,
        paymentLocations: {
          ...state.paymentLocations,
          ...action.payload,
        },
      };
    case RequestFormActionType.SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        service: {
          ...state.service,
          ...action.payload,
        },
      };
    case RequestFormActionType.PROVIDER_REQUEST_SUCCESS:
      return {
        ...state,
        providers: {
          ...state.providers,
          ...action.payload,
        },
      };
    case RequestFormActionType.UPDATE_DRAFT_SAVE:
      return {
        ...state,
        draftSaved: {
          ...state.draftSaved,
          [action.payload.key]: action.payload.value,
        },
      };
    case RequestFormActionType.UPDATE_UNSAVED_CHANGES:
      return {
        ...state,
        unsavedChanges: {
          ...state.unsavedChanges,
          [action.payload.key]: action.payload.value,
        },
      };
    case RequestFormActionType.PACKING_DETAIL_SUCCESS:
      return {
        ...state,
        packingList: {
          ...state.packingList,
          [action.payload.key]: action.payload.value,
        },
      };
    case RequestFormActionType.UPDATE_DISABLED_FIELDS:
      return {
        ...state,
        disabledFields: {
          ...state.disabledFields,
          [action.payload.key]: action.payload.value,
        },
      };
    case RequestFormActionType.UPDATE_TOOLTIP_FIELDS:
      return {
        ...state,
        tooltipFields: {
          ...state.tooltipFields,
          [action.payload.key]: action.payload.value,
        },
      };
    default:
      throw new Error();
  }
};
